export default __webpack_public_path__ + "static/10-fb2b722ff3d7c0f5feb72e05e4f86da5.webp";